import React, { useEffect, useState } from "react";
import {
    Grid,
    Paper } from "../../ui";
import SnpButton from "../../global/SnpButton";
import {
  CART_INITIAL_STATE,
  DashboardComponent,
  GET_BILL_CATEOGORY_DATA,
  getDeviceTypeNew,
  getPreUrlAccordingToCart,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import { setBaseCateogoryData } from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import { snpAxios } from "../../global/api";
import { addDataIndb } from "../../global/indexedDB";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { useNavigate } from "react-router-dom";
import { useDeviceType } from "../../global/hooks/useDeviceType";

const CategoryCard = ({ handleCateogoryClick }) => {
  const categoryData = useSelector(
    (state) => state.setCateogoryReducer.cateogoryData
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const [loader, showLoader] = useState(false);
  const { snackbar, dialog } = useSnpUI();
  const { isMobile, isTablet } = useDeviceType(getDeviceTypeNew);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (categoryData.length === 0) {
      getCateogoryData();
    }
  }, []);

   useEffect(() => {
      getCateogoryData();
  
  }, [storeActiveShopHash]);

  useEffect(() => {}, [categoryData]);

  const getCateogoryData = async () => {
    showLoader(true);
    const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(
      storeActiveShopHash.cartType
    )}${GET_BILL_CATEOGORY_DATA}`;
    let data = {
      jcJson: {
        apiToken: CART_INITIAL_STATE.apiToken,
        shopHash: storeActiveShopHash.id,
      },
    };
    // //printLog("getCateogoryData => ",data);
    await snpAxios
      .post(catgUrl, data)
      .then((response) => {
        printDebugLog("getCateogoryData => ", response.data);
        if (response.data.status === SUCCESS) {
          showLoader(false);
          //setBaseCateogoryData(response.data.jcJson.value_2);
          addDataIndb({
            id: storeActiveShopHash.id,
            value: response.data.jcJson.value_2,
          });
        dispatch(setBaseCateogoryData(response.data.jcJson.value_2));
        } else {
          dialog.show({
            negativeReq: true,
            negativeAction: "Home",
            positiveAction: "Add Cateogory",
            positiveReq: true,
            outSideClickDismiss: false,
            cancelExtra: true,
            requestType: DashboardComponent.CATEOGORY,
            subTitle: "No Cateogory is available! Please add",
            onConfirmAction: () => {
              navigate("/dashboard/cateogory");
            },
          });
          showLoader(false);
        }
      })
      .catch((error) => {
        console.error("getCateogoryData err", error);
        dialog.show({
          negativeReq: true,
          negativeAction: "Home",
          outSideClickDismiss: false,
          cancelExtra: true,
          requestType: 1,
          subTitle: "Internet Connection Lost",
        });
        showLoader(false);
        //printLog("Error : ", error);
        //window.location.href = "#/error";
      });
  };

  const paperStyles = {
    borderRadius: 4,
    margin: "2px",
    backgroundColor: "rgb(194, 204, 180)",
  };

  const getFontSize = (length) => (length > 24 ? "9px" : "12px");

  //const handleClickWrapper = useCallback((data) => () => handleCateogoryClick(data), [handleCateogoryClick]);
  return (
    <Grid
      container
      spacing={2}
      sx={{ mb: 1 }}
      columns={{  xs: 12, md: isTablet ? 12 : 2 }}
      minWidth= {{lg: 200}}
    >
      {/* <>{console.log("RenderCateogoryCard")}</> */}
      <Grid item xs={12}>
        <center>
          <SnpButton mbgcolor="#3d6554" onClick={getCateogoryData}>
            Refresh Cateogory
          </SnpButton>
        </center>
      </Grid>
      {categoryData &&
        categoryData.map((data) => (
          <Grid item md={ isTablet ? 3 : 1} xs={ isTablet ? 3 : 4}  sm={3} key={data.id}>
            <Paper
              elevation={0}
              onClick={() => handleCateogoryClick(data)}
              className="restaurant-right-data-container"
              sx={paperStyles}
            >
              <center>
                {/* <>{console.log("CategoryCard")}</> */}
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    fontSize: getFontSize(data.catgName.length),
                  }}
                >
                  <b>{data.catgName}</b>
                </p>
              </center>
            </Paper>
          </Grid>
        ))}
    </Grid>
  );
};

export default CategoryCard;
